import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { NamedLink, ExternalLink } from '../../components';
import { ensureHttps } from '../../util/data';

import css from './ListingPage.module.css';

const DetailItem = props => {
  const { detailHeading, detailValue, linkParams, externalLinkParams } = props;
  return (
    <div className={css.detail}>
      <span className={css.detailHeading}>{detailHeading}</span>
      {linkParams ? (
        <NamedLink className={css.detailValue} {...linkParams}>
          {detailValue}
        </NamedLink>
      ) : externalLinkParams ? (
        <ExternalLink {...externalLinkParams}>{detailValue}</ExternalLink>
      ) : (
        <span className={css.detailValue}>{detailValue}</span>
      )}
    </div>
  );
};

const SectionDetails = props => {
  const { listingFields, organizationProfile } = props;

  if (!listingFields.launch && !listingFields.countryOfOrigin && !organizationProfile) {
    return null;
  }

  return (
    <div className={css.sectionDetails}>
      <h2 className={css.detailsTitle}>
        <FormattedMessage id="ListingPage.detailsTitle" />
      </h2>
      <div className={css.details}>
        {listingFields.launch ? (
          <DetailItem detailHeading="Launch" detailValue={listingFields.launch} />
        ) : null}
        {listingFields.countryOfOrigin ? (
          <DetailItem
            detailHeading="Country of origin"
            detailValue={listingFields.countryOfOrigin}
          />
        ) : null}
        {organizationProfile && (
          <DetailItem
            detailHeading="Production company"
            detailValue={organizationProfile.name}
            linkParams={{
              name: 'OrganizationProfilePage',
              params: { id: organizationProfile.id },
            }}
          />
        )}
        {listingFields.website ? (
          <DetailItem
            detailHeading="Website"
            detailValue={listingFields.website}
            externalLinkParams={{
              href: ensureHttps(listingFields.website),
            }}
          />
        ) : null}
      </div>
    </div>
  );
};

export default SectionDetails;
